import { cn } from "@/lib/utils";

type LoadingAnimationSize = "blocking" | "fullPage";

interface LoadingAnimationProps {
  size: LoadingAnimationSize;
}

/** Decorative Figma loading artwork used by AppShellContent loading states. */
function LoadingAnimation({ size }: LoadingAnimationProps) {
  return (
    <svg
      aria-hidden="true"
      className={cn(
        "aw-loading-animation shrink-0",
        size === "fullPage" ? "size-[100px]" : "size-(--icon-xxl)",
      )}
      data-slot="loading-animation"
      fill="none"
      viewBox="0 0 48 48"
    >
      <path
        className="fill-outline-subtle opacity-40"
        d="M4.8 24c0 10.605 8.595 19.2 19.2 19.2 8.085 0 15-4.995 17.835-12.068-.495 1.23-1.89 1.83-3.12 1.335-1.23-.495-1.83-1.89-1.335-3.128-2.123 5.31-7.313 9.06-13.38 9.06-7.95 0-14.4-6.45-14.4-14.4 0-7.95 6.45-14.4 14.4-14.4.698 0 1.388.053 2.063.143-1.313-.188-2.22-1.403-2.033-2.715.188-1.29 1.365-2.198 2.655-2.048a19.262 19.262 0 0 0-2.685-.188C13.395 4.793 4.8 13.388 4.8 23.993V24Z"
      />
      <path
        className="fill-primary-fixed"
        d="M24.023 7.027c.187-1.312 1.402-2.22 2.715-2.032C36.045 6.33 43.2 14.325 43.2 24c0 2.513-.488 4.92-1.365 7.133-.495 1.23-1.89 1.83-3.12 1.335-1.23-.495-1.83-1.89-1.335-3.12.66-1.65 1.028-3.45 1.028-5.348 0-7.253-5.363-13.253-12.338-14.258-1.313-.188-2.22-1.403-2.033-2.715h-.015Z"
      />
    </svg>
  );
}

export { LoadingAnimation };
